var map = {
	"./FaceTecStrings.af.js": [
		52726,
		"src_assets_core-sdk-optional_FaceTecStrings_af_js"
	],
	"./FaceTecStrings.ar.js": [
		84827,
		"src_assets_core-sdk-optional_FaceTecStrings_ar_js"
	],
	"./FaceTecStrings.de.js": [
		64051,
		"src_assets_core-sdk-optional_FaceTecStrings_de_js"
	],
	"./FaceTecStrings.el.js": [
		72305,
		"src_assets_core-sdk-optional_FaceTecStrings_el_js"
	],
	"./FaceTecStrings.en.js": [
		686,
		"src_assets_core-sdk-optional_FaceTecStrings_en_js"
	],
	"./FaceTecStrings.es.js": [
		36523,
		"src_assets_core-sdk-optional_FaceTecStrings_es_js"
	],
	"./FaceTecStrings.fr.js": [
		88394,
		"src_assets_core-sdk-optional_FaceTecStrings_fr_js"
	],
	"./FaceTecStrings.ja.js": [
		81330,
		"src_assets_core-sdk-optional_FaceTecStrings_ja_js"
	],
	"./FaceTecStrings.kk.js": [
		95637,
		"src_assets_core-sdk-optional_FaceTecStrings_kk_js"
	],
	"./FaceTecStrings.no.js": [
		55671,
		"src_assets_core-sdk-optional_FaceTecStrings_no_js"
	],
	"./FaceTecStrings.pt-br.js": [
		78876,
		"src_assets_core-sdk-optional_FaceTecStrings_pt-br_js"
	],
	"./FaceTecStrings.ru.js": [
		80429,
		"src_assets_core-sdk-optional_FaceTecStrings_ru_js"
	],
	"./FaceTecStrings.vi.js": [
		42719,
		"src_assets_core-sdk-optional_FaceTecStrings_vi_js"
	],
	"./FaceTecStrings.zh.js": [
		47886,
		"src_assets_core-sdk-optional_FaceTecStrings_zh_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94879;
module.exports = webpackAsyncContext;